<template>
  <div class="text-c">
    <van-nav-bar title="支付结果检测" left-arrow />
    <van-image :src="imgSrc" style="width: 50%; margin-top: 30%"></van-image>
    <p>检测支付结果</p>
    <van-button
      type="danger"
      @click="testing"
      class="m-l-03 b-r-013 goLook m-t-04"
      >检测</van-button
    >
    <p @click="goHome" class="m-t-04" style="font-size: 0.8rem; color: #fd7d15">
      回首页
    </p>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { getOrderByApplyNo } from "@/model/pay/payServer";

export default {
  data() {
    return {
      imgSrc: require("@/assets/imgs/empty/pay.png"),
      orderNumber: "",
      type: "",
      status: "",
      confirmButtonText: "",
      num:0
    };
  },
  created() {
    this.type = this.$route.query.type; // 1是资料  2是课程
    this.testing();
  },
  methods: {
    init() {
      if (this.type == "1") {
        this.getGroupMsg();
      } else if (this.type == "2") {
        this.getclassDetials();
      }
    },
    // 获取课程的详情
    getclassDetials() {
      let data = {
        cid: this.$route.query.cid,
      };
      this.Api({
        url: "api/course/getCourseDetails",
        method: "POST",
        data,
      }).then((res) => {
        if (res.data.status == "1") {
          this.confirmButtonText = "去课程详情";
        } else if (res.data.status == "2") {
          this.confirmButtonText = "失败";
        } else {
          this.confirmButtonText = "邀请好友";
        }
        this.testing();
      });
    },
    // 获取资料详情
    getGroupMsg() {
      let belong = this.$route.query.belongGroupId;
      this.Api({
        url:
          belong == undefined
            ? `api/datumtPinByPid?pid=${this.$route.query.cid}`
            : `api/datumtPinByPid?pid=${this.$route.query.cid}&orderGroupId=${belong}`,
        method: "GET",
      }).then((res) => {
        if (res.retuCode == 5000) {
          if (res.data.pinstatus == "1") {
            this.confirmButtonText = "去资料详情";
          } else if (res.data.pinstatus == "2") {
            this.confirmButtonText = "失败";
          } else {
            this.confirmButtonText = "邀请好友";
          }
          this.testing();
        } else {
          alert("获取资料未知错误,请联系学习规划老师");
        }
      });
    },
    // 检测支付结果
    testing() {
      this.orderNumber = this.$route.query.orderNumber;
      this.status = this.$route.query.status; // 1 //状态 1.成功,2失败没有订单 3.已支付拼团未成功
      let routePath = "/BIMDetials";
      if (this.type == "1") {
        routePath = "/BIMDetials";
      } else if (this.type == "2") {
        routePath = "/details";
      }
      getOrderByApplyNo({ orderNumber: this.orderNumber })
        .then((data) => {
          let _that = this;
          if(data.data.state == "2"){
            this.testing()
            return false
          }else if(data.data.state == "1"){
            _that.confirmButtonText = "查看详情"
          }else {
            _that.confirmButtonText = "邀请好友"
          }
          if (data.data.state == "1" || data.data.state == "3") {
            Dialog.confirm({
              message: "支付成功",
              confirmButtonText: _that.confirmButtonText,
              cancelButtonText: "回首页",
            })
              .then(() => {
                this.$router.push({
                  path: routePath,
                  query: {
                    isPay: true,
                    cid: this.$route.query.cid,
                    pid: this.$route.query.cid,
                    belongGroupId : data.data.orderGroupId
                  },
                });
              })
              .catch(() => {
                this.$router.push({
                  path: "/",
                });
              });
          } else {
            Dialog.confirm({
              message: "支付失败",
              confirmButtonText: "重新支付",
            })
              .then(() => {
                this.$router.push({
                  path: "/",
                });
              })
              .catch(() => {
                this.$router.push({
                  path: "/",
                });
              });
          }
        })
        .catch(() => {
          Dialog.confirm({
            message: "支付失败",
            confirmButtonText: "重新支付",
          })
            .then(() => {
              this.$router.push({
                path: "/",
              });
            })
            .catch(() => {
              this.$router.push({
                path: "/",
              });
            });
        });
    },
    goHome() {
      this.$router.push({
        path: "/",
      });
    },

    goDataList() {
      this.$router.push({
        path: "/BIMDetials",
        query: {
          isPay: true,
          pid: this.$route.query.pid,
        },
      });
    },
  },
};
</script>

<style scoped>
.goLook {
  background: linear-gradient(90deg, #fd7b11 0%, #ff9546 100%);
  box-shadow: 0rem 0.3rem 0.55rem 0rem rgba(253, 125, 20, 0.4);
  border-radius: 1.3rem;
  width: 8.15rem;
  border: none;
}
</style>